import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import styles from "./ProductsPage.module.scss";

// --- Inline SVGs ---
const Icons = {
  Cpu: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="2em"
      height="2em"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect x="4" y="4" width="16" height="16" rx="2" ry="2"></rect>
      <rect x="9" y="9" width="6" height="6"></rect>
      <line x1="9" y1="1" x2="9" y2="4"></line>
      <line x1="15" y1="1" x2="15" y2="4"></line>
      <line x1="9" y1="20" x2="9" y2="23"></line>
      <line x1="15" y1="20" x2="15" y2="23"></line>
      <line x1="20" y1="9" x2="23" y2="9"></line>
      <line x1="20" y1="14" x2="23" y2="14"></line>
      <line x1="1" y1="9" x2="4" y2="9"></line>
      <line x1="1" y1="14" x2="4" y2="14"></line>
    </svg>
  ),
  Cloud: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="2em"
      height="2em"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M18 10h-1.26A8 8 0 1 0 9 20h9a5 5 0 0 0 0-10z"></path>
    </svg>
  ),
  Layers: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="2em"
      height="2em"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <polygon points="12 2 2 7 12 12 22 7 12 2"></polygon>
      <polyline points="2 17 12 22 22 17"></polyline>
      <polyline points="2 12 12 17 22 12"></polyline>
    </svg>
  ),
  Shield: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="2em"
      height="2em"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
    </svg>
  ),
  BookOpen: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="2em"
      height="2em"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"></path>
      <path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"></path>
    </svg>
  ),
  Edit3: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="2em"
      height="2em"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M12 20h9"></path>
      <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"></path>
    </svg>
  ),
  PieChart: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="2em"
      height="2em"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M21.21 15.89A10 10 0 1 1 8 2.83"></path>
      <path d="M22 12A10 10 0 0 0 12 2v10z"></path>
    </svg>
  ),
  Inbox: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="2em"
      height="2em"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <polyline points="22 12 16 12 14 15 10 15 8 12 2 12"></polyline>
      <path d="M5.45 5.11L2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z"></path>
    </svg>
  ),
  Map: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="2em"
      height="2em"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <polygon points="1 6 1 22 8 18 16 22 23 18 23 2 16 6 8 2 1 6"></polygon>
      <line x1="8" y1="2" x2="8" y2="18"></line>
      <line x1="16" y1="6" x2="16" y2="22"></line>
    </svg>
  ),
  CreditCard: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="2em"
      height="2em"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect x="1" y="4" width="22" height="16" rx="2" ry="2"></rect>
      <line x1="1" y1="10" x2="23" y2="10"></line>
    </svg>
  ),
  Video: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="2em"
      height="2em"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <polygon points="23 7 16 12 23 17 23 7"></polygon>
      <rect x="1" y="5" width="15" height="14" rx="2" ry="2"></rect>
    </svg>
  ),
};

const modes = [
  {
    icon: Icons.Cpu,
    name: "APIs",
    text: "Banking, open finance, KYC, e-mandate, risk, identity, and compliance—exposed as clean, secure APIs.",
  },
  {
    icon: Icons.Cloud,
    name: "SaaS",
    text: "Prebuilt applications for collections, engagement, loan origination, risk, and more—ready to deploy.",
  },
  {
    icon: Icons.Layers,
    name: "PaaS",
    text: "Build, deploy, and run your own services on our platform with governed access and enterprise controls.",
  },
];

const PRODUCT_SUITE = [
  {
    id: "verifyx",
    name: "VerifyX AI",
    slug: "verifyx",
    tag: "Identity & KYC",
    description:
      "Next-generation identity verification engine. Leveraging biometric synchronization for institutional compliance and absolute security.",
    icon: Icons.Shield,
  },
  {
    id: "legal-ai",
    name: "Legal AI",
    slug: "legal-ai",
    tag: "Legal ops",
    description:
      "AI-powered audit engine designed for cognitive analysis of complex regulatory datasets and legal contract extraction.",
    icon: Icons.BookOpen,
  },
  {
    id: "dokgen",
    name: "Dokgen AI",
    slug: "dokgen-ai",
    tag: "Document generation",
    description:
      "Modular document automation framework. Instantly generates regulatory-compliant reports and complex legal filings from consulting datasets.",
    icon: Icons.Edit3,
  },
  {
    id: "email-to-case",
    name: "Email to Case",
    slug: "email-to-case",
    tag: "Service automation",
    description:
      "Automate your operations with AI that processes emails and documents—saving time, reducing errors, and boosting efficiency",
    icon: Icons.Inbox,
  },
  {
    id: "live-tracker",
    name: "Live Tracker",
    slug: "live-tracker",
    tag: "Observability",
    description:
      "Real-time infrastructure visualization and global asset tracking for decentralized consultancy teams and client monitoring.",
    icon: Icons.Map,
  },
  {
    id: "billing-ai",
    name: "Billing AI",
    slug: "billing-ai",
    tag: "Revenue",
    description:
      "Generate, revise, track, and deliver invoices at scale with built-in compliance, audit trails, and intelligent automation.",
    icon: Icons.CreditCard,
  },
  {
    id: "vpd",
    name: "VPD",
    slug: "vpd-ai",
    tag: "Verification",
    description:
      "Video identity, documents, and policy in one defensible experience.",
    icon: Icons.Video,
  },
];

const pageVariants = {
  hidden: { opacity: 0, y: 8 },
  show: { opacity: 1, y: 0, transition: { duration: 0.35 } },
};
const listParent = { show: { transition: { staggerChildren: 0.05 } } };
const item = {
  hidden: { opacity: 0, y: 12 },
  show: { opacity: 1, y: 0, transition: { duration: 0.35 } },
};
const modeHover = {
  y: -6,
  transition: { type: "spring", stiffness: 400, damping: 25 },
};

/** Abstract API mesh — Updated for Light Theme */
const HeroArt = () => (
  <div className={styles["page-products-hero-art"]} aria-hidden>
    <div className={styles["page-products-hero-art-glow"]} />
    <svg
      className={styles["page-products-hero-svg"]}
      viewBox="0 0 440 360"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <linearGradient id="pp-line" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#4f46e5" stopOpacity="0.4" />
          <stop offset="100%" stopColor="#0ea5e9" stopOpacity="0.2" />
        </linearGradient>
        <radialGradient id="pp-node" cx="50%" cy="50%" r="50%">
          <stop offset="0%" stopColor="#4f46e5" stopOpacity="0.9" />
          <stop offset="100%" stopColor="#0ea5e9" stopOpacity="0.4" />
        </radialGradient>
        <filter id="pp-glow" x="-50%" y="-50%" width="200%" height="200%">
          <feGaussianBlur stdDeviation="4" result="b" />
          <feMerge>
            <feMergeNode in="b" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
      </defs>
      <path
        d="M40 180 L120 100 L200 200 L300 60 L380 200"
        stroke="url(#pp-line)"
        strokeWidth="1.5"
        strokeLinecap="round"
        fill="none"
        opacity="0.8"
      />
      <path
        d="M120 100 L200 200 L300 60"
        stroke="url(#pp-line)"
        strokeWidth="1.2"
        strokeDasharray="4 6"
        fill="none"
        opacity="0.6"
      />
      <path
        d="M80 260 L180 220 L280 280 L360 240"
        stroke="url(#pp-line)"
        strokeWidth="1.2"
        fill="none"
        opacity="0.6"
      />
      <circle
        className={styles["page-products-hero-node"]}
        cx="120"
        cy="100"
        r="10"
        fill="url(#pp-node)"
        filter="url(#pp-glow)"
      />
      <circle
        className={styles["page-products-hero-node"]}
        cx="200"
        cy="200"
        r="14"
        fill="url(#pp-node)"
        filter="url(#pp-glow)"
      />
      <circle
        className={styles["page-products-hero-node"]}
        cx="300"
        cy="60"
        r="9"
        fill="url(#pp-node)"
        filter="url(#pp-glow)"
      />
      <circle
        className={styles["page-products-hero-node"]}
        cx="380"
        cy="200"
        r="11"
        fill="url(#pp-node)"
        filter="url(#pp-glow)"
      />
      <circle
        className={styles["page-products-hero-node"]}
        cx="180"
        cy="220"
        r="8"
        fill="url(#pp-node)"
        filter="url(#pp-glow)"
      />
      <circle
        className={styles["page-products-hero-node"]}
        cx="280"
        cy="280"
        r="8"
        fill="url(#pp-node)"
        filter="url(#pp-glow)"
      />
      <rect
        x="80"
        y="150"
        width="32"
        height="20"
        rx="4"
        stroke="#4f46e5"
        strokeOpacity="0.25"
        fill="rgba(79,70,229,0.05)"
      />
      <rect
        x="280"
        y="120"
        width="36"
        height="24"
        rx="4"
        stroke="#0ea5e9"
        strokeOpacity="0.25"
        fill="rgba(14,165,233,0.05)"
      />
    </svg>
  </div>
);

const ProductsPage = () => {
  return (
    <>
      <div className="page-page-root">
        <motion.main
          className={styles["page-products-page"]}
          initial="hidden"
          animate="show"
          variants={pageVariants}
        >
          {/* HERO SECTION */}
          <section
            className={styles["page-products-hero"]}
            aria-labelledby="products-hero-title"
          >
            <div className={styles["page-products-hero-ambient"]} aria-hidden />
            <div className={styles["page-products-hero-grid"]} aria-hidden />

            <div className="sec-container">
              <div className={styles["page-products-hero-row"]}>
                <div className={styles["page-products-hero-inner"]}>
                  <span className="page-eyebrow">Products</span>
                  <h1 className="page-title" id="products-hero-title">
                    One platform.{" "}
                    <span className="page-title-accent">
                      Three ways to consume it.
                    </span>
                  </h1>
                  <p className="page-lead">
                    APIs for integration, ready-made SaaS for go-live speed, and
                    a PaaS option when you need to build and host your own
                    services.
                  </p>
                  <div className="page-trust-list" role="list">
                    <span className="page-trust-pill" role="listitem">
                      ISO 27001
                    </span>
                    <span className="page-trust-pill" role="listitem">
                      ISO 9001:2015
                    </span>
                    <span className="page-trust-pill" role="listitem">
                      VAPT in progress
                    </span>
                    <span className="page-trust-pill" role="listitem">
                      DPDPA-ready
                    </span>
                    <span className="page-trust-pill" role="listitem">
                      BFSI-grade controls
                    </span>
                  </div>
                </div>
                <HeroArt />
              </div>
            </div>
          </section>

          {/* MAIN CONTENT */}
          <div className="page-main">
            <div className="sec-container">
              {/* Consumption Modes Grid */}
              <motion.div
                className={styles["page-modes-grid"]}
                role="list"
                variants={listParent}
                initial="hidden"
                animate="show"
              >
                {modes.map((m) => {
                  const Ic = m.icon;
                  return (
                    <motion.div
                      key={m.name}
                      className={styles["page-mode-card"]}
                      role="listitem"
                      variants={item}
                      whileHover={modeHover}
                    >
                      <div className={styles["page-mode-icon"]} aria-hidden>
                        <Ic />
                      </div>
                      <strong className={styles["page-mode-name"]}>{m.name}</strong>
                      <p className={styles["page-mode-text"]}>{m.text}</p>
                    </motion.div>
                  );
                })}
              </motion.div>

              {/* Compliance Banner */}
              <p className="page-compliance-banner">
                <Icons.Shield />
                <span>
                  BFSI-grade: encryption in transit, secrets management, audit,
                  DR and continuity, and integration with your IAM.
                </span>
              </p>

              {/* REPLACED SAAS SHELF: Ready-to-use products built on Doql */}
              <div className="page-ps-section light" id="products-suite">
                <motion.div
                  className="page-ps-intro"
                  initial={{ opacity: 0, y: 18 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, margin: "-80px" }}
                  transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
                >
                  <span className="page-eyebrow">SaaS on the same core</span>
                  <h2 className="page-ps-h2">
                    Ready-to-use products built on Doql
                  </h2>
                  <p className="page-ps-lede">
                    VerifyX, DokGen, LegalAI, LiveTracker, Email-to-Case,
                    Billing — purchase, configure, and go live with the same
                    compliance posture as our APIs and PaaS.
                  </p>
                </motion.div>

                <motion.ul
                  className="page-ps-cards"
                  variants={listParent}
                  initial="hidden"
                  whileInView="show"
                  viewport={{ once: true, margin: "-60px" }}
                >
                  {PRODUCT_SUITE.map((product) => {
                    const Ic = product.icon;
                    return (
                      <motion.li
                        key={product.id}
                        className="page-ps-card"
                        variants={item}
                      >
                        <div className="page-ps-card-head">
                          <span className="page-ps-icon" aria-hidden>
                            <Ic />
                          </span>
                          <div className="page-ps-title-block">
                            <h3 className="page-ps-name">{product.name}</h3>
                            <code className="page-ps-slug">
                              {product.slug}.doql.com
                            </code>
                          </div>
                        </div>
                        <span className="page-ps-chip">{product.tag}</span>
                        <p className="page-ps-desc">{product.description}</p>
                        <Link
                          to={`/products/${product.slug}`}
                          className="page-ps-cta"
                        >
                          See product
                        </Link>
                      </motion.li>
                    );
                  })}
                </motion.ul>
              </div>

              {/* Bottom CTA */}
              <div
                className="page-bottom-cta"
                role="group"
                aria-label="Next steps"
              >
                <p>Align pricing, pilots, and rollout with your org.</p>
                <div className="page-cta-row">
                  <Link to="/pricing" className="page-btn page-btn-primary">
                    View pricing →
                  </Link>
                  <Link to="/contact" className="page-btn page-btn-secondary">
                    Contact Us
                  </Link>
                </div>
                <p className="page-footer-note">
                  <Link to="/contact" className="page-footer-link">
                    Talk to us about deployment, regions, and SLAs →
                  </Link>
                </p>
              </div>
            </div>
          </div>
        </motion.main>
      </div>
    </>
  );
};

export default ProductsPage;
